import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomPin = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <path
            d={
                'M13.3333 10L15 11.6667V13.3333H10.8333V18.3333L10 19.1667L9.16667 18.3333V13.3333H5V11.6667L6.66667 10V4.16667H5.83333V2.5H14.1667V4.16667H13.3333V10Z'
            }
        />
    </SvgIcon>
);
